import { Link, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

export const SignupHereLink = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const handleLogin = () => {
    navigate("/sign-up");
  };
  return (
    <div
      className="signup-here-container"
      style={{ display: "flex", flexDirection: "column" }}
    >
      <Typography variant="bodySmall">{t("opva.dontHaveAccount")}</Typography>
      <Typography variant="bodySmall">
        {t("opva.signup")}{" "}
        <Link variant="h6" onClick={handleLogin}>
          {t("opva.here")}
        </Link>
      </Typography>
    </div>
  );
};
